import langReducer from "./language";
import { combineReducers } from "redux";

const reducers = combineReducers({
  language: langReducer
});

export default reducers;
